'use client';

import Image from 'next/image';
import Link from 'next/link';
import ArrowRightBlack2424 from '@svg/main/arrow_right_black_24_24.svg';

export default function NeedLoginBox({ type }: { type: '저장된 장소' | '나의 여행' }) {
  return (
    <>
      <div className='flex flex-col pt-48pxr pb-24pxr px-28pxr'>
        <Image
          src='https://hoolzzuk-public-images.s3.ap-northeast-2.amazonaws.com/3_seconds_sign_up_tool_tip.png'
          alt='sign_up_tool_tip'
          width={156}
          height={42}
          className='w-156pxr h-42pxr animate-bounce'
        />
        <Link
          href={process.env.NEXT_PUBLIC_ZZIMCAR_URL + 'user/signin?redirectUrl=' + process.env.NEXT_PUBLIC_PLANNER_URL}
          prefetch={false}
          className='flex flex-row items-center justify-between w-full border border-gray-200 p-14pxr rounded-8pxr'
          style={{ boxShadow: '0px 2px 8px 0px rgba(193, 209, 217, 0.50)' }}
        >
          <div className='flex flex-col text-left gap-4pxr heading-16-b text-custom-black'>
            <p>{type} 리스트는</p>
            <p>
              <span className='text-info'>찜카 회원</span>만 볼 수 있어요.
            </p>
          </div>
          <ArrowRightBlack2424 className='flex-none' />
        </Link>
        <div className='flex flex-row items-start gap-12pxr mt-16pxr'>
          <p className='text-gray-800 body-14-r'>지금 찜카 회원가입 하고{'\n'}플래너의 다양한 기능을 만나보세요.</p>
        </div>
      </div>
    </>
  );
}
